import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold mb-2">PRIVACY POLICY</h1>
        <p className="text-gray-600">Last updated: March 13, 2025</p>
      </div>

      <div className="mb-8">
        <p className="mb-4">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>
        <p>
          We use Your Personal data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy.
        </p>
      </div>

      {/* Interpretation and Definitions */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          INTERPRETATION AND DEFINITIONS
        </h2>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">INTERPRETATION</h3>
          <p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-2">DEFINITIONS</h3>
          <p className="mb-4">For the purposes of this Privacy Policy:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Account</strong> means a unique account created for You to
              access our Service or parts of our service.
            </li>
            <li>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by or is under common control with a party.
            </li>
            <li>
              <strong>Application</strong> means the software program provided
              by the Company downloaded by You on any electronic device, named
              X.
            </li>
            <li>
              <strong>Company</strong> (referred to as either &quot;the
              Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot;
              in this Agreement) refers to Nom d&apos;entreprise, adresse
              postale.
            </li>
            <li>
              <strong>Country</strong> refers to: France
            </li>
            <li>
              <strong>Data Controller</strong> for the purposes of the GDPR,
              refers to the Company as the legal person which determines the
              purposes and means of the processing of Personal Data.
            </li>
            <li>
              <strong>Device</strong> means any device that can access the
              Service such as a computer, a cellphone or a digital tablet.
            </li>
            <li>
              <strong>Personal Data</strong> is any information that relates to
              an identified or identifiable individual.
            </li>
            <li>
              <strong>Service</strong> refers to the Application.
            </li>
            <li>
              <strong>Service Provider</strong> means any natural or legal
              person who processes the data on behalf of the Company.
            </li>
            <li>
              <strong>Usage Data</strong> refers to data collected
              automatically, either generated by the use of the Service or from
              the Service infrastructure itself.
            </li>
            <li>
              <strong>You</strong> means the individual accessing or using the
              Service.
            </li>
          </ul>
        </div>
      </div>

      {/* Collecting and Using Your Personal Data */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          COLLECTING AND USING YOUR PERSONAL DATA
        </h2>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">
            Types of Data Collected
          </h3>

          <div className="mb-4">
            <h4 className="text-lg font-medium mb-2">PERSONAL DATA</h4>
            <p>
              While using Our Service, We may ask You to provide Us with certain
              personally identifiable information that can be used to contact or
              identify You. Personally identifiable information may include, but
              is not limited to: Email address, First name and last name, Phone
              number, Address, State, Province, ZIP/Postal code, City, Usage
              Data.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-2">USAGE DATA</h4>
            <p>
              Usage Data is collected automatically when using the Service.
              Usage Data may include information such as Your Device&apos;s
              Internet Protocol address (e.g. IP address), browser type, browser
              version, the pages of our Service that You visit, the time and
              date of Your visit, the time spent on those pages, unique device
              identifiers and other diagnostic data.
            </p>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">
            Use of Your Personal Data
          </h3>
          <p className="mb-4">
            The Company may use Personal Data for the following purposes:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              To provide and maintain our Service, including to monitor the
              usage of our Service.
            </li>
            <li>
              To manage Your Account: to manage Your registration as a user of
              the Service.
            </li>
            <li>
              For the performance of a contract: the development, compliance and
              undertaking of the purchase contract for the products, items or
              services You have purchased.
            </li>
            <li>
              To contact You: contact You by email, telephone calls, SMS, or
              other equivalent forms of electronic communication.
            </li>
            <li>
              To provide You with news, special offers and general information
              about other goods, services and events.
            </li>
            <li>
              To manage Your requests: To attend and manage Your requests to Us.
            </li>
            <li>
              For business transfers: We may use Your information to evaluate or
              conduct a merger, divestiture, restructuring, reorganization.
            </li>
            <li>
              For other purposes: We may use Your information for other
              purposes, such as data analysis, identifying usage trends.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">
            Retention of Your Personal Data
          </h3>
          <p>
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations, resolve disputes, and enforce our legal
            agreements and policies.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">
            Transfer of Your Personal Data
          </h3>
          <p>
            Your information, including Personal Data, is processed at the
            Company&apos;s operating offices and in any other places where the
            parties involved in the processing are located. The Company will
            take all steps reasonably necessary to ensure that Your data is
            treated securely and in accordance with this Privacy Policy.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-2">
            Disclosure of Your Personal Data
          </h3>
          <div className="space-y-4">
            <div>
              <h4 className="text-lg font-medium mb-2">
                BUSINESS TRANSACTIONS
              </h4>
              <p>
                If the Company is involved in a merger, acquisition or asset
                sale, Your Personal Data may be transferred. We will provide
                notice before Your Personal Data is transferred and becomes
                subject to a different Privacy Policy.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-medium mb-2">LAW ENFORCEMENT</h4>
              <p>
                Under certain circumstances, the Company may be required to
                disclose Your Personal Data if required to do so by law or in
                response to valid requests by public authorities.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-medium mb-2">
                OTHER LEGAL REQUIREMENTS
              </h4>
              <p>
                The Company may disclose Your Personal Data in the good faith
                belief that such action is necessary to comply with a legal
                obligation, protect and defend the rights or property of the
                Company, prevent or investigate possible wrongdoing in
                connection with the Service, protect the personal safety of
                Users of the Service or the public, or protect against legal
                liability.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Detailed Information on the Processing of Your Personal Data */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          DETAILED INFORMATION ON THE PROCESSING OF YOUR PERSONAL DATA
        </h2>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold mb-2">Analytics</h3>
            <p className="mb-4">
              We may use third-party Service providers to monitor and analyze
              the use of our Service.
            </p>

            <div className="mb-4">
              <h4 className="text-lg font-medium mb-2">Google Analytics</h4>
              <p className="mb-2">
                Google Analytics is a web analytics service offered by Google
                that tracks and reports website traffic. You may opt-out of
                certain Google Analytics features through your mobile device
                settings.
              </p>
              <p>
                For more information on the privacy practices of Google, please
                visit the{" "}
                <a
                  href="https://policies.google.com/privacy"
                  className="text-blue-600 hover:underline"
                >
                  Google Privacy & Terms web page
                </a>
                .
              </p>
            </div>

            <div>
              <h4 className="text-lg font-medium mb-2">Firebase</h4>
              <p className="mb-2">
                Firebase is an analytics service provided by Google Inc. You may
                opt-out of certain Firebase features through your mobile device
                settings.
              </p>
              <p>
                For more information on what type of information Firebase
                collects, please visit the{" "}
                <a
                  href="https://policies.google.com/privacy"
                  className="text-blue-600 hover:underline"
                >
                  How Google uses data
                </a>{" "}
                webpage.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Email Marketing</h3>
            <p className="mb-2">
              We may use Your Personal Data to contact You with newsletters,
              marketing or promotional materials and other information that may
              be of interest to You. You may opt-out of receiving any, or all,
              of these communications from Us by following the unsubscribe link
              or instructions provided in any email We send or by contacting Us.
            </p>
            <p>
              We may use Email Marketing Service Providers to manage and send
              emails to You.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Payments</h3>
            <p className="mb-2">
              We may provide paid products and/or services within the Service.
              In that case, we may use third-party services for payment
              processing (e.g. payment processors).
            </p>
            <p>
              We will not store or collect Your payment card details. That
              information is provided directly to Our third-party payment
              processors whose use of Your personal information is governed by
              their Privacy Policy.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">
              Behavioral Remarketing
            </h3>
            <p className="mb-4">
              The Company uses remarketing services to advertise to You after
              You accessed or visited our Service. We and Our third-party
              vendors use cookies and non-cookie technologies to help Us
              recognize Your Device and understand how You use our Service.
            </p>
            <p className="mb-2">
              You may opt-out of all personalized advertising by enabling
              privacy features on Your mobile device such as Limit Ad Tracking
              (iOS) and Opt Out of Ads Personalization (Android).
            </p>
            <p className="mb-2">The third-party vendors We use are:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Google Ads (AdWords)</strong> -{" "}
                <a
                  href="http://www.google.com/settings/ads"
                  className="text-blue-600 hover:underline"
                >
                  Google Ads Settings
                </a>
              </li>
              <li>
                <strong>Facebook</strong> -{" "}
                <a
                  href="https://www.facebook.com/help/516147308587266"
                  className="text-blue-600 hover:underline"
                >
                  Facebook interest-based ads
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* GDPR Privacy */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">GDPR PRIVACY</h2>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold mb-2">
              Legal Basis for Processing Personal Data under GDPR
            </h3>
            <p className="mb-4">
              We may process Personal Data under the following conditions:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Consent</strong>: You have given Your consent for
                processing Personal Data for one or more specific purposes.
              </li>
              <li>
                <strong>Performance of a contract</strong>: Provision of
                Personal Data is necessary for the performance of an agreement
                with You.
              </li>
              <li>
                <strong>Legal obligations</strong>: Processing Personal Data is
                necessary for compliance with a legal obligation.
              </li>
              <li>
                <strong>Vital interests</strong>: Processing Personal Data is
                necessary in order to protect Your vital interests.
              </li>
              <li>
                <strong>Public interests</strong>: Processing Personal Data is
                related to a task that is carried out in the public interest.
              </li>
              <li>
                <strong>Legitimate interests</strong>: Processing Personal Data
                is necessary for the purposes of the legitimate interests
                pursued by the Company.
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">
              Your Rights under the GDPR
            </h3>
            <p className="mb-4">
              You have the right under this Privacy Policy, and by law if You
              are within the EU, to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Request access to Your Personal Data.</li>
              <li>
                Request correction of the Personal Data that We hold about You.
              </li>
              <li>Object to processing of Your Personal Data.</li>
              <li>Request erasure of Your Personal Data.</li>
              <li>Request the transfer of Your Personal Data.</li>
              <li>Withdraw Your consent.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">
              Exercising of Your GDPR Data Protection Rights
            </h3>
            <p className="mb-2">
              You may exercise Your rights of access, rectification,
              cancellation and opposition by contacting Us. Please note that we
              may ask You to verify Your identity before responding to such
              requests.
            </p>
            <p>
              You have the right to complain to a Data Protection Authority
              about Our collection and use of Your Personal Data. For more
              information, if You are in the European Economic Area (EEA),
              please contact Your local data protection authority in the EEA.
            </p>
          </div>
        </div>
      </div>

      {/* Facebook Fan Page */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">FACEBOOK FAN PAGE</h2>

        <div className="space-y-4">
          <p>
            The Company is the Data Controller of Your Personal Data collected
            while using the Service. As operator of the Facebook Fan Page, the
            Company and the operator of the social network Facebook are Joint
            Controllers.
          </p>
          <p>
            The Company has entered into agreements with Facebook that define
            the terms for use of the Facebook Fan Page. These terms are mostly
            based on the{" "}
            <a
              href="https://www.facebook.com/terms.php"
              className="text-blue-600 hover:underline"
            >
              Facebook Terms of Service
            </a>
            .
          </p>
          <p>
            Visit the{" "}
            <a
              href="https://www.facebook.com/policy.php"
              className="text-blue-600 hover:underline"
            >
              Facebook Privacy Policy
            </a>{" "}
            for more information about how Facebook manages Personal data.
          </p>
        </div>
      </div>

      {/* Children&apos;s Privacy */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">CHILDREN&apos;S PRIVACY</h2>
        <p>
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from anyone
          under the age of 13. If You are a parent or guardian and You are aware
          that Your child has provided Us with Personal Data, please contact Us.
        </p>
      </div>

      {/* Links to Other Websites */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">LINKS TO OTHER WEBSITES</h2>
        <p>
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party&apos;s site. We strongly advise You to review the
          Privacy Policy of every site You visit.
        </p>
      </div>

      {/* Changes to This Privacy Policy */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          CHANGES TO THIS PRIVACY POLICY
        </h2>
        <p className="mb-2">
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page.
        </p>
        <p className="mb-2">
          We will let You know via email and/or a prominent notice on Our
          Service, prior to the change becoming effective and update the
          &quot;Last updated&quot; date at the top of this Privacy Policy.
        </p>
        <p>
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </p>
      </div>

      {/* Contact Us */}
      <div>
        <h2 className="text-2xl font-bold mb-4">CONTACT US</h2>
        <p className="mb-2">
          If you have any questions about this Privacy Policy, You can contact
          us:
        </p>
        <p>
          By email:{" "}
          <a
            href="mailto:contact@mail"
            className="text-blue-600 hover:underline"
          >
            contact@mail
          </a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
